/** @file nextPowerOfTwo: the smallest power of two at least n. */

/** The smallest power of two ≥ `n`; 1 for `n ≤ 1`. */
export function nextPowerOfTwo(n: number): number {
  let p = 1;
  while (p < n) p *= 2;
  return p;
}
